import { render } from "./income.vue?vue&type=template&id=3cac311b&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=3cac311b&scoped=true&lang=less"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cac311b"]])

export default __exports__